<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="part" id="p01"><a id="page4"></a><a id="page5"></a><a href="#/OEBPS/toc.htm#p01">The Rise<br/>of<br/><i>El Doctor</i></a></h1>
<p class="center">1948–1989</p>
<p class="break"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?105ce136